export const MILISECONDS_FOR = {
  ONE_DAY: 1000 * 60 * 60 * 24,
  ONE_MINUTE: 1000 * 60 * 1,
}
